import { callApiWithoutToken } from './api';

import { PerformanceRecordStatusRequest } from '@/types/performanceRecord';

export const updatePerformanceRecordStatus = async (
  childID: number,
  performanceRecordID: number,
  lineAccessToken: string,
  input: PerformanceRecordStatusRequest
) => {
  const { status, result } = await callApiWithoutToken<boolean>(
    `line/children/${childID}/performance-records/${performanceRecordID}/status`,
    'PUT',
    lineAccessToken,
    undefined,
    input
  );
  return { status, result };
};
